// extracted by mini-css-extract-plugin
module.exports = {"container":"_2rVTw-zQ_zOsfF07-tMDK7","icon":"_1m-HPaxSu90Z6nO8pVtlek"};